import React from "react";
import useStartTest from "./useStartTest";
import Instructions from "./Instructions";
import ExamMode from "./ExamMode";
import TestAndQuesInfo from "./TestAndQuesInfo";

const StartTestPage = () => {
  const {
    showNextPage,
    examModeHandler,
    startExamHandler,
    testDetails,
    state,
  } = useStartTest();
  return (
    <>
      {state?.isNextPage ? (
        <Instructions isNextPage={showNextPage} />
      ) : state.startTest ? (
        <ExamMode
          startExamHandler={startExamHandler}
          examModeHandler={examModeHandler}
          mode={state.examMode}
        />
      ) : testDetails?.EvalutionMode && testDetails?.PracticeMode ? (
        <TestAndQuesInfo
          data={testDetails}
          id={testDetails?.objectId}
          mode={state.examMode}
        />
      ) : testDetails?.EvalutionMode ? (
        <TestAndQuesInfo
          data={testDetails}
          id={testDetails?.objectId}
          mode={true}
        />
      ) : testDetails?.PracticeMode ? (
        <TestAndQuesInfo
          data={testDetails}
          id={testDetails?.objectId}
          mode={false}
        />
      ) : null}
    </>
  );
};

export default StartTestPage;
